import { BOLT_BACKEND_URL } from 'constants/envs.ts'
import { createBaseQueryWithReauth } from 'store/queries/utils.ts'

export const baseQueryWithReauth = createBaseQueryWithReauth(BOLT_BACKEND_URL)
